import React from 'react';
import styled from '@emotion/styled';
import { themeGet } from 'styled-system';
import { Container, Flex } from 'roo-ui/components';
import HeaderLinks from 'components/Header/HeaderLinks';

const ContainerBackground = styled(Flex)`
  background-color: rgba(51, 51, 51, 1);
  color: ${themeGet('colors.white')};
`;

const NavigationLinks = () => {
  return (
    <ContainerBackground>
      <Container>
        <HeaderLinks />
      </Container>
    </ContainerBackground>
  );
};

export default NavigationLinks;
